import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkc031aRequest, SGKC031AService, ReimporttargetLstInfo } from 'sg-api';

/**
 * ガス確定使用量再取込対象取得API使用サービス
 * @export
 * @class UsedSgkc031aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc031aService {

    /** ガス確定使用量再取込対象取得結果のSubject */
    private _reimportTargetListResult$: Subject<Array<ReimporttargetLstInfo>> = new Subject<Array<ReimporttargetLstInfo>>();

    /**
     * コンストラクタ
     * @param {SGKC031AService} sGKC031AService
     * @param {ApiCommonService} apiCommonService
     * @param {TimeApiService} timeApiService
     * @param {FeaturesLibConfig} featuresLibConfig
     * @memberof UsedSgkc031aService
     */
    constructor(
        private sGKC031AService: SGKC031AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
    ) { }

    /**
     * ガス確定使用量再取込対象取得結果のobservable提供
     * @readonly
     * @memberof UsedSgkc031aService
     */
    get reimportTargetListChanges() {
        return this._reimportTargetListResult$.asObservable();
    }

    /**
     * ガス確定使用量再取込対象取得API呼び出し
     * @param {Sgkc031aRequest} request 
     * @return {Observable<Array<ReimporttargetLstInfo>>} 
     * @memberof UsedSgkc031aService
     */
    searchGasReimportTargetlList(request: Sgkc031aRequest): Observable<Array<ReimporttargetLstInfo>> {
        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
        // 検索条件を保存
        return this.sGKC031AService.kC10RSGKC031APost(<Sgkc031aRequest>this.apiCommonService.setRequestCommon(request), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    this._reimportTargetListResult$.next(response.body.reimporttargetLstInformationlist);
                    return response.body.reimporttargetLstInformationlist;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC031A');
                    return throwError(err.message);
                })
            );
    }
}
